import { render, staticRenderFns } from "./prescription-details.vue?vue&type=template&id=6e029714&"
import script from "./prescription-details.vue?vue&type=script&lang=js&"
export * from "./prescription-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports